export const FILE_MEGA_BYTES_SIZE_MAX_LIMIT = 1.5
export const FILE_BYTES_SIZE_MAX_LIMIT = FILE_MEGA_BYTES_SIZE_MAX_LIMIT * 1024 * 1024 // 1.5 MB
